module.exports = __webpack_public_path__ + "img/silverShadowMob (1).35cc1d7d.webp";